<div class="todo-container">
    <h1>Todo List with Signals</h1>

    <form class="add-todo" [formGroup]="todoForm">
        <input type="text" formControlName="todoMessageInput" (keyup.enter)="addTodo()"
            placeholder="What needs to be done?" class="todo-input" />
        <button (click)="addTodo()" class="btn btn-add">Add Todo</button>
    </form>

    <div class="stats">
        <p>
            Total: {{ totalTodos() }} | Active: {{ activeTodos() }} | Completed:
            {{ completedTodos() }}
        </p>
    </div>

    <div class="filter-buttons">
        <button (click)="updateTodoList('ALL')" [class.active]="store.filter() === 'ALL'" class="btn btn-filter">
            All
        </button>
        <button (click)="updateTodoList('ACTIVE')" [class.active]="store.filter() === 'ACTIVE'" class="btn btn-filter">
            Active
        </button>
        <button (click)="updateTodoList('COMPLETED')" [class.active]="store.filter() === 'COMPLETED'"
            class="btn btn-filter">
            Completed
        </button>
    </div>

    <ul class="todo-list">
        <li *ngFor="let todo of allTodos" class="todo-item" [class.completed]="todo.isCompleted">
            <ng-container>
                <input type="checkbox" [checked]="todo.isCompleted" (change)="toggleTodo(todo._id)"
                    class="todo-checkbox" />
                <span class="todo-text">{{ todo.message }}</span>
                <button (click)="deleteTodo(todo._id)" class="btn btn-delete">
                    Delete
                </button>
            </ng-container>
        </li>
    </ul>

    <div *ngIf="filteredTodos().length === 0" class="empty-state">
        <p>{{ getEmptyMessage() }}</p>
    </div>
</div>